import Cookies from 'js-cookie';

const DEFAULT_PAGES_BEFORE_POPUP = 2;
const DELAY = 800;
const DISMISS_DAYS = 7;
const COOKIE_REGION = 'fadoq_region';
const COOKIE_VIEWS = 'fadoq_geo_views';
const COOKIE_LAST_PATH = 'fadoq_geo_last_path';
const COOKIE_DISMISSED = 'fadoq_geo_popup_dismissed';

const $popup = document.querySelector('.geolocation-popup');

let openTimeout;
let previouslyFocused;

function pagesBeforePopup() {
    const value = $popup.dataset.pagesBeforePopup?.trim();

    if (!value) return DEFAULT_PAGES_BEFORE_POPUP;

    const pages = Number(value);

    return Number.isInteger(pages) && pages >= 0 ? pages : DEFAULT_PAGES_BEFORE_POPUP;
}

function forget() {
    Cookies.remove(COOKIE_VIEWS, { path: '/' });
    Cookies.remove(COOKIE_LAST_PATH, { path: '/' });
}

function countPageView() {
    const path = window.location.pathname;

    if (Cookies.get(COOKIE_LAST_PATH) === path) {
        return Number(Cookies.get(COOKIE_VIEWS) || 0);
    }

    const views = Number(Cookies.get(COOKIE_VIEWS) || 0) + 1;

    Cookies.set(COOKIE_VIEWS, views, { expires: 30, path: '/' });
    Cookies.set(COOKIE_LAST_PATH, path, { expires: 30, path: '/' });

    return views;
}

function onCloseEnd(event) {
    if (event.target !== $popup) return;

    $popup.hidden = true;
    $popup.removeEventListener('transitionend', onCloseEnd);
}

function restoreFocus() {
    const $target = previouslyFocused;
    previouslyFocused = null;

    if (!$target || $target === document.body || !$target.isConnected) return;

    $target.focus({ preventScroll: true });
}

function close({ restore = true } = {}) {
    clearTimeout(openTimeout);

    if ($popup.hidden) return;

    const hadFocus = $popup.contains(document.activeElement);

    $popup.classList.remove('opened');
    $popup.addEventListener('transitionend', onCloseEnd);

    if (restore && hadFocus) {
        restoreFocus();
    } else {
        previouslyFocused = null;
    }
}

function dismiss() {
    Cookies.set(COOKIE_DISMISSED, '1', { expires: DISMISS_DAYS, path: '/' });
    forget();
    close();
}

function open() {
    previouslyFocused = document.activeElement;

    $popup.removeEventListener('transitionend', onCloseEnd);
    $popup.hidden = false;
    $popup.getBoundingClientRect();
    $popup.classList.add('opened');

    const $firstFocusable = $popup.querySelector('.btn-close') || $popup.querySelector('.btn-open-panel');
    $firstFocusable?.focus({ preventScroll: true });
}

function openPanel() {
    close({ restore: false });
    document.dispatchEvent(new CustomEvent('fadoq:openGeolocationPanel'));
}

// Called by geolocation-panel.js when the automatic geolocation fails.
export default function notifyGeolocationFailed() {
    if (!$popup) return;
    if (Cookies.get(COOKIE_DISMISSED)) return;
    if (countPageView() <= pagesBeforePopup()) return;

    openTimeout = setTimeout(open, DELAY);
}

if ($popup) {
    if (Cookies.get(COOKIE_REGION)) {
        forget();
    }

    $popup.querySelector('.btn-open-panel')?.addEventListener('click', (event) => {
        event.stopPropagation();
        openPanel();
    });
    $popup.querySelector('.btn-close')?.addEventListener('click', dismiss);

    ['fadoq:megaMenuOpened', 'fadoq:searchPanelOpened'].forEach((event) => {
        document.addEventListener(event, () => close());
    });

    document.addEventListener('fadoq:geolocationPanelOpened', () => close({ restore: false }));
}
